export const BackgroundType = {
    WHITE:1,
    YELLOW: 2,
    BLUE: 3,
    DARK_BLUE: 4
}